import { render, staticRenderFns } from "./MentionsLegales.vue?vue&type=template&id=3e0acca0&scoped=true&"
import script from "./MentionsLegales.vue?vue&type=script&lang=js&"
export * from "./MentionsLegales.vue?vue&type=script&lang=js&"
import style0 from "./MentionsLegales.vue?vue&type=style&index=0&id=3e0acca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0acca0",
  null
  
)

export default component.exports